import { Video } from "../../../components/Video"

const PaywallVideo = () => (
  <div data-testid="paywall-video">
    <Video
      name="personal-advisor-paywall-video"
      thumbnailSrc="https://9337776.fs1.hubspotusercontent-na1.net/hubfs/9337776/Demo%20Videos/NCX%20Personal%20Advisor%20thumbnail.png"
      src="https://9337776.fs1.hubspotusercontent-na1.net/hubfs/9337776/Demo%20Videos/NCX%20Personal%20Advisor.mp4"
    />
  </div>
)

export default PaywallVideo
